import { render, staticRenderFns } from "./indexnew.vue?vue&type=template&id=b6f0431a&scoped=true&"
import script from "./indexnew.vue?vue&type=script&lang=js&"
export * from "./indexnew.vue?vue&type=script&lang=js&"
import style0 from "./indexnew.vue?vue&type=style&index=0&id=b6f0431a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f0431a",
  null
  
)

export default component.exports